export enum ActionModalSize {
    Default = 'default',
    Large = 'large',
}
